module.exports = __webpack_public_path__ + "img/proyecto_8.573640ee.png";